import { render, staticRenderFns } from "./HeaderControlsReport.vue?vue&type=template&id=4fc854bc&scoped=true&"
import script from "./HeaderControlsReport.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsReport.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsReport.vue?vue&type=style&index=0&id=4fc854bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc854bc",
  null
  
)

export default component.exports